// extracted by mini-css-extract-plugin
export default {"componentAnimate":"b3z7vJ","rotation":"c3z7vJ"};